import { useTheme } from "@emotion/react";
import { Button, Grid2, Snackbar } from "@mui/material";
import { useTranslation } from "react-i18next";
import { dangerButton } from "../../../styles/commonStyles";
import ExportButtonGroup from "./ExportButtonGroup";
import { useState } from "react";

/**
 * PageActions Component
 * @param {Function} onReset - Function to reset data (optional)
 * @param {Function} onShare - Function to share (optional)
 * @param {Array} tableHeaders - Headers for export data
 * @param {Array} tableRows - Data rows for export
 * @param {String} fileName - Export file name
 */
const PageActions = ({ onReset, onShare, tableHeaders, tableRows, fileName, isDisabled = false }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleShare = async () => {
    if (onShare) {
      await onShare();
      setOpenSnackbar(true); // Show feedback message
    }
  };

  return (
    <Grid2 sx={{ display: "flex", gap: 2, justifyContent: "flex-start", mb: 2 }}>
      {onReset && (
        <Button variant="contained" sx={dangerButton(theme)} onClick={onReset}>
          {t("shoppingListPage.resetToRecipes")}
        </Button>
      )}

      <ExportButtonGroup fileName={fileName} tableHeaders={tableHeaders} tableRows={tableRows} isDisabled={isDisabled} />

      {onShare && (
        <Button variant="contained" onClick={handleShare} disabled={isDisabled}>
          {t("share")}
        </Button>
      )}
      <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={() => setOpenSnackbar(false)} message={t("linkCopied")} />
    </Grid2>
  );
};

export default PageActions;
